import { MapRenderer, MapRendererConfig, RendererName } from "../OperationRenderer";
import { TrackPoint, UnitHashElement } from "@context/map/units/unitsStore";
import * as PIXI from "pixi.js";
import { LINE_CAP, LINE_JOIN } from "pixi.js";
import LeafletPixiOverlayService, { OverlaySetting } from "../../LeafletPixiOverlayService";
import Logger from "@utils/logger";
import { EntityId } from "@reduxjs/toolkit";
import { unitSelectors } from "../../../../store/reducers/units";
import { store } from "../../../../store";

const log = Logger.getLogger("unit.track.renderer")
export default class TrackRenderer extends MapRenderer<UnitHashElement> {
    container: PIXI.Container | undefined;
    enabled: boolean = false

    getZIndex(): number {
        return 14;
    }

    name = RendererName.UnitTrack;

    constructor(config: MapRendererConfig) {
        super(config)
    }

    redraw(unitIds: EntityId[]): void {
        for (const unitId of unitIds) {
            const unit = unitSelectors.selectById(store.getState().units, unitId)
            const layerId = unitId
            const unitTrackGraphic = this.container?.getChildByName(layerId as string) as PIXI.Graphics
            if (!unitTrackGraphic) {
                log.error("Not found a layer in container with id", layerId, this.container)
            } else if (unit) {
                let { trackPoints } = unit.dynamic;
                let { project } = this.settings

                if (trackPoints) {
                    unitTrackGraphic.clear()
                    unitTrackGraphic.lineStyle({
                        width: .05,
                        color: 0x006400,
                        alpha: 1,
                        cap: LINE_CAP.ROUND,
                        join: LINE_JOIN.ROUND,
                        // native: true
                    })
                    trackPoints.forEach((point: TrackPoint, index: number, array: any) => {
                        let { x, y } = project([point.lat, point.lon])
                        if (index === 0) unitTrackGraphic.moveTo(x, y)
                        else unitTrackGraphic.lineTo(x, y);
                    })
                }
            }
        }
    }

    render(unitIds: EntityId[]): void {
        for (const unitId of unitIds) {
            if (!this.container?.getChildByName(unitId as string)) {
                let unitTrackGraphic = new PIXI.Graphics()
                unitTrackGraphic.name = unitId as string
                unitTrackGraphic.zIndex = this.getZIndex()
                this.container?.addChild(unitTrackGraphic)
            }
        }
    }
}